<script>
import rolesTable from './roles.table'
import getExportedFilename from '@lib/utils/get-exported-filename'
import CreateRoleModal from './create-role-modal'

export default {
  name: 'Roles',
  components: { CreateRoleModal },
  data() {
    return {
      table: rolesTable(this),
      modals: {
        create: false,
      },
    }
  },
  methods: {
    onRowClick(row) {
      this.$router.push({
        name: 'role',
        params: {
          id: row.id,
        },
      })
    },
    getExportedFilename() {
      return getExportedFilename(this.table.tableName)
    },
    onCreateRole() {
      this.modals.create = true
    },
  },
}
</script>

<template>
  <main-layout
    title="Roles"
  >
    <template slot="header">
      <el-button
        type="primary"
        @click="onCreateRole"
      >
        Create Role
      </el-button>
    </template>
    <table-layout
      :table-name="table.tableName"
      :fragments="false"
      hider
      :quantity="[25, 50, 100, 200]"
      :processor="table.processor"
      :filters="table.filters"
      :columns="table.columns"
      :export-filename="getExportedFilename"
      @row-click="onRowClick"
    />
    <create-role-modal
      v-if="modals.create"
      :processor="table.processor"
      :visible.sync="modals.create"
      @close-modal="modals.create = false"
    />
  </main-layout>
</template>
